var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { transformMessage } from '@freelancer/datastore/messages';
import { toNumber } from '@freelancer/utils';
import { ContextTypeApi, FolderApi, PrivacyLevelApi, } from 'api-typings/messages/messages_types';
// TODO: thread: any inference needs to go. ContextApi is incorrect.
export function transformThread(thread, userId) {
    var baseThread = thread.thread;
    if (!baseThread.id) {
        throw new Error('Threads should have an id');
    }
    if (!baseThread.owner) {
        throw new Error('Threads should have an owner');
    }
    var userReadTimes = Object.entries(baseThread.user_read_times || {}).reduce(function (acc, _a) {
        var _b;
        var memberId = _a[0], readTime = _a[1];
        return (__assign(__assign({}, acc), (readTime ? (_b = {}, _b[memberId] = readTime * 1000, _b) : {})));
    }, {});
    var threadHighlights = !thread.highlights || thread.highlights.length === 0
        ? undefined
        : thread.highlights.map(buildThreadHighlights);
    return {
        context: transformContext(baseThread.context),
        folder: thread.folder || FolderApi.INBOX,
        highlights: threadHighlights,
        id: thread.id,
        isBlocked: thread.is_blocked || false,
        isFake: false,
        isMuted: thread.is_muted || false,
        isRead: thread.is_read || false,
        members: baseThread.members || [],
        inactiveMembers: baseThread.inactive_members || [],
        message: baseThread.message
            ? transformMessage(baseThread.message)
            : undefined,
        messageCount: thread.message_count,
        messageUnreadCount: thread.message_unread_count || 0,
        otherMembers: baseThread.members.filter(function (m) { return m !== toNumber(userId); }),
        owner: baseThread.owner,
        threadType: baseThread.thread_type,
        timeCreated: (baseThread.time_created || 0) * 1000,
        timeRead: (thread.time_read || 0) * 1000,
        timeUpdated: (thread.time_updated || 0) * 1000,
        userReadTimes: userReadTimes,
        writePrivacy: baseThread.write_privacy || PrivacyLevelApi.MEMBERS,
    };
}
// Turn { type = 'none', id = undefined } => undefined
function transformContext(context) {
    return context && context.id && context.type !== ContextTypeApi.NONE
        ? {
            type: context.type,
            id: context.id,
        }
        : {
            type: ContextTypeApi.NONE,
        };
}
function buildThreadHighlights(highlight) {
    return {
        field: highlight.field,
        highlightedText: {
            preceding: highlight.highlighted_text[0] || '',
            highlighted: highlight.highlighted_text[1] || '',
            succeeding: highlight.highlighted_text[2] || '',
        },
    };
}
